const COURSE_ACCESS_FREE = 1;
const COURSE_ACCESS_CLASS_CODE = 2;
const COURSE_ACCESS_PAY = 3;
const COURSE_ACCESS_VIP = 4;

const COURSE_MODE_CHALLENGE = 1; //闯关模式
const COURSE_MODE_SCHEDULE = 2; //排课模式
const COURSE_MODE_FREE = 3; //学霸模式，不锁定课程

//1、锁定中;2.学习中;3.学习完成，未开始作业;4.作业中;5.全部完成;6.作业未通过;7.作业通过
const LESSON_PROGRESS_UNLOCK = 1;
const LESSON_PROGRESS_STUDYING = 2;
const LESSON_PROGRESS_TODO_HOMEWORK = 3;
const LESSON_PROGRESS_HOMEWORKING = 4;
const LESSON_PROGRESS_DONE = 5;
const LESSON_PROGRESS_HOMEWORK_FAIL = 6;
const LESSON_PROGRESS_HOMEWORK_PASS = 7;

const TASK_PROGRESS_DOING = 2;
const TASK_PROGRESS_DONE = 3;
// 1.手把手教学;2.编程操作;3.试玩;4.视频观看;
const TASK_TYPE_GUIDE = 1;
const TASK_TYPE_PROGRAM = 2;
const TASK_TYPE_PLAY = 3;
const TASK_TYPE_VIDEO = 4;

const GUIDE_MODE = 1; //引导模式
const TRAIN_MODE = 2; //练习模式
const BATCH_TIPS_MODE = 3; //纯提示模式
const EXAMPLE_MODE = 3; //例程模式

const ZINDEX_CHAT_BOX = 512; //聊天窗口的zindex
const ZINDEX_FOCUS_COVER = 520; //引导模式下的焦点遮罩的zindex
const ZINDEX_SYSTEM_BTN = 530; //系统
const ZINDEX_TIPS_ARROW = 600; //提示文本和箭头
const OPACITY_FOCUS_COVER = 0.3; //引导模式下的焦点遮罩的透明度


export {
    COURSE_ACCESS_FREE,
    COURSE_ACCESS_CLASS_CODE,
    COURSE_ACCESS_PAY,

    COURSE_MODE_CHALLENGE,
    COURSE_MODE_SCHEDULE,
    COURSE_MODE_FREE,

    LESSON_PROGRESS_STUDYING,
    LESSON_PROGRESS_TODO_HOMEWORK,
    LESSON_PROGRESS_HOMEWORKING,
    LESSON_PROGRESS_DONE,
    LESSON_PROGRESS_HOMEWORK_FAIL,
    LESSON_PROGRESS_HOMEWORK_PASS,

    TASK_PROGRESS_DOING,
    TASK_PROGRESS_DONE,

    TASK_TYPE_GUIDE,
    TASK_TYPE_PROGRAM,
    TASK_TYPE_PLAY,
    TASK_TYPE_VIDEO,

    GUIDE_MODE,
    TRAIN_MODE,
    BATCH_TIPS_MODE,
    EXAMPLE_MODE,

    ZINDEX_FOCUS_COVER,
    ZINDEX_TIPS_ARROW,
    OPACITY_FOCUS_COVER,
    ZINDEX_SYSTEM_BTN
}
